import Grid from "@mui/material/Grid";
import PickRowTopMoments from "../PickRowTopMoments";
import {Divider} from "@mui/material";
import {Pick} from "../../../../data/models/bracket_api/Pick";
import Paper from "@mui/material/Paper";
import {Result} from "../../../../data/models/bracket_api/Result";
import {Qualifier} from "../../../../data/models/bracket_api/Qualifier";
import {Driver} from "../../../../data/models/bracket_api/Driver";

export type TwoWidePickBlockTopMomentsProps = {
    pick?: Pick,
    result?: Result,
    updatePick: (pick: Pick) => void,
    picks_locked: boolean,
    qualifiers?: Qualifier[],
}

/** Raw qualifier seed is 1–64; map to 1–16 (first four → 1, next four → 2, etc.). */
function qualifierSeedToDisplaySeed(rawSeed: number): number {
    return Math.ceil(rawSeed / 4);
}

export function seedForCompetitor(competitorNumber: 1 | 2, pick: Pick | undefined, result: Result | undefined, qualifiers: Qualifier[] | undefined): number | undefined {
    const driver: Driver | undefined = competitorNumber === 1
        ? (pick?.competitor_1 ?? result?.competitor_1)
        : (pick?.competitor_2 ?? result?.competitor_2);
    const rawSeed = qualifiers?.find((q) => q.driver === driver)?.seed;
    if (rawSeed === undefined || rawSeed === null) return undefined;
    return qualifierSeedToDisplaySeed(rawSeed);
}

export default function PickBlockTopMoments({pick, result, updatePick, picks_locked, qualifiers}: Readonly<TwoWidePickBlockTopMomentsProps>){
    const seed1 = seedForCompetitor(1, pick, result, qualifiers);
    const seed2 = seedForCompetitor(2, pick, result, qualifiers);
    return (
        <Grid container component={Paper} m={1} sx={{
            display: 'flex',
            flexDirection: "column",
            height: 'fit-content',
            width: 'fit-content',
        }}>
            <PickRowTopMoments
                competitor_number={1}
                pick={pick}
                result={result}
                onClick={updatePick}
                picks_locked={picks_locked}
                fourWide={false}
                seed={seed1}
            />
            <Divider/>
            <PickRowTopMoments
                competitor_number={2}
                pick={pick}
                result={result}
                onClick={updatePick}
                picks_locked={picks_locked}
                fourWide={false}
                seed={seed2}
            />
        </Grid>
    )
}
